import script from "./goRinSyo0043.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0043.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0043.vue?vue&type=style&index=0&id=8d7560c6&lang=scss"

const __exports__ = script;

export default __exports__